import { useEffect, useState } from "react";
import { LoadTimeout } from "./load-timeout";
import { getLoadStallMs } from "@/lib/with-timeout";
import { PageSpinner } from "./page-spinner";

export function GlobalPending() {
  const [stalled, setStalled] = useState(false);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | undefined;

    const arm = () => {
      clearTimeout(timer);
      const prerendering = (document as Document & { prerendering?: boolean })
        .prerendering;
      if (document.visibilityState === "visible" && !prerendering) {
        // Slow connections get a longer grace period (see getLoadStallMs).
        timer = setTimeout(() => setStalled(true), getLoadStallMs());
      }
    };

    arm();
    document.addEventListener("visibilitychange", arm);
    document.addEventListener("prerenderingchange", arm);
    return () => {
      clearTimeout(timer);
      document.removeEventListener("visibilitychange", arm);
      document.removeEventListener("prerenderingchange", arm);
    };
  }, []);

  if (stalled) return <LoadTimeout />;

  return <PageSpinner className="bg-background" />;
}
